<script>
  import { ShopboxHomeApp } from '@shopboxai/sb-home-app';
  import { userToken, currentUser } from '../stores';
</script>

<ShopboxHomeApp user={JSON.stringify($userToken)} currentClient={$currentUser.fullClientId} />
